import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { PageResponse } from "@models/page-response";
import { Message } from '@models/message';

const BASE_API_URL = process.env.REACT_APP_API_URL;


export interface GetMessagesQuery {
  patientId: string;
  sessionId?: string;
  search?: string;
}

export const messageApi = createApi({
  reducerPath: "messageApi",
  tagTypes: ["Message"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/messages`,
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    getMessages: builder.query<PageResponse<Message>, GetMessagesQuery>({
      providesTags: ["Message"],
      query: (params: GetMessagesQuery) => {
        return {
          url: ``,
          method: "GET",
          params: params,
        };
      },
    }),
  }),
});

export const {
  useGetMessagesQuery,
} = messageApi;
